import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';

export const ADMIN_ACCOUNT_OPEN_INVOICE_SUMMARY_QUERY_KEY = 'admin/account/<accountId>/openInvoiceSummary';

/** The account's stored open-invoice summary (no Chargify call); `null` when nothing is owed. */
export function useAdminAccountOpenInvoiceSummaryQuery({
	accountId,
	enabled = true,
}: {
	accountId: string;
	enabled?: boolean;
}) {
	const userSession = useAdminUserSession();
	return useQuery({
		queryKey: [ADMIN_ACCOUNT_OPEN_INVOICE_SUMMARY_QUERY_KEY, accountId],
		queryFn: async () =>
			(await userSession.webServiceHelper.callAsync<Api.IOpenInvoiceSummary | null>(
				`admin/account/${encodeURIComponent(accountId)}/openInvoiceSummary`,
				'GET'
			)) ?? null,
		enabled: enabled && !!accountId,
		retry: false,
	});
}
